export class ListGoogleWorkspaceSharedDrives200Response {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sharedDrives",
            "baseName": "sharedDrives",
            "type": "Array<GoogleWorkspaceSharedDrive>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextPageToken",
            "baseName": "nextPageToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListGoogleWorkspaceSharedDrives200Response.attributeTypeMap;
    }
    constructor() {
    }
}
